import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import 'react-toastify/dist/ReactToastify.css';
import { Web3AuthProvider } from './web3/Web3AuthContext';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Web3AuthProvider>
        <App />
      </Web3AuthProvider>
    </BrowserRouter>
  </StrictMode>
);